/**
 * Kopfzeile der Grundkalender-Karte (Board „Vertrieb“): Apartmentfilter mit Mehrfachauswahl, der
 * Hinweis je Recht, „Zeitraum bearbeiten“ mit Edit und das Menü ⋯ mit „Alles neu übertragen“ nur
 * mit Full. Ohne Recht wird ein Knopf nicht gerendert, nicht deaktiviert.
 */
import type { ReactNode } from 'react';
import { MoreHorizontal } from 'lucide-react';
import type { AvailabilityDistributionApartment } from '@/shared/api';
import { ActionMenu, PropertyCombobox } from '@/shared/components';

interface Props {
  apartments: AvailabilityDistributionApartment[];
  /** null = alle Apartments. */
  filter: Set<string> | null;
  onFilterChange: (next: Set<string> | null) => void;
  canEdit: boolean;
  canFullSync: boolean;
  /** Nur mit Bearbeitungsrecht gesetzt. */
  periodAction?: ReactNode;
  onFullResync: () => void;
}

export function GrundkalenderToolbar({
  apartments,
  filter,
  onFilterChange,
  canEdit,
  canFullSync,
  periodAction,
  onFullResync,
}: Props) {
  return (
    <div className="border-hairline flex flex-wrap items-center gap-3 border-b px-[18px] py-3.5">
      <PropertyCombobox
        options={apartments.map((apartment) => ({
          id: apartment.propertyId,
          name: apartment.name,
        }))}
        selected={filter}
        onChange={onFilterChange}
      />
      <span className="text-ink-soft text-[13px]">
        {canEdit ? 'Freie Tage einer Zeile anklicken: Beginn und Ende markieren' : 'Nur ansehen'}
      </span>
      <span className="grow" aria-hidden />
      {periodAction}
      {canFullSync && (
        <ActionMenu
          trigger={
            <button
              type="button"
              aria-label="Weitere Aktionen"
              className="rounded-pill border-line text-ink hover:bg-card-alt grid size-11 place-items-center border"
            >
              <MoreHorizontal size={18} aria-hidden />
            </button>
          }
          items={[{ label: 'Alles neu übertragen', icon: 'Refresh', onClick: onFullResync }]}
        />
      )}
    </div>
  );
}
